// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2VSAU","footer":"ChangeClinic_footer___ooDH"};